import apiRequest from 'lib/apiRequest';

type TranslationResponse = {
  translation: string;
};

const TranslationActions = {
  translate(text: string, locale: string): Promise<TranslationResponse> {
    return apiRequest(`/translations/${locale}`, 'GET', {
      q: text,
    });
  },
};

export default TranslationActions;
